import CardFormula1 from "./cardF1/cardF1";
import CardGlobal from "./cardGlobal/cardGlobal";
import CardTenis from "./cardTenis/cardTenis";

/**
 * Componente que renderiza dinámicamente la tarjeta deportiva según el deporte.
 */
export default function RenderCardCarrousel({ item, flagMomios, patrocinador, indexJson }) {
  const { sport = "" } = item;
  const sportKey = sport.toUpperCase();
  const commonProps = { data: item, flagMomios, patrocinador, indexJson };

  const cardComponents = {
    MTR: CardFormula1,
    TNS: CardTenis,
  };

  const CardComponent = cardComponents[sportKey] || CardGlobal;

  return <CardComponent {...commonProps} />;
}